import script from "./Page7.vue?vue&type=script&setup=true&lang=js"
export * from "./Page7.vue?vue&type=script&setup=true&lang=js"

import "./Page7.vue?vue&type=style&index=0&id=6bda6878&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bda6878"]])

export default __exports__